import { AolGroup } from '../../types/ViewModel/AolItem';
import { getDateFromFormat, formatDateTime, DateTimeFormat } from 'odfjell-date-time-utils/dateTimeFormatter';
import { getDateFromISO } from 'odfjell-date-time-utils/dateTimeUtils';


export const getAolGroupDate = (aolGroup: AolGroup) => getDateFromFormat(aolGroup.aolDate, DateTimeFormat.queryFormats.dateOnly);
export const getAolDateLocalTime = (date: string) => getDateFromFormat(date, DateTimeFormat.queryFormats.dateOnly);

export const getAolDateFromUrlFormat = (date: string) => getDateFromFormat(date, DateTimeFormat.urlFormats.dateOnly);
export const getAolFromToTimeFromUrlFormat = (date: string) => getDateFromISO(date);

export const formatAolGroupDate = (date: Date) => formatDateTime(date, DateTimeFormat.queryFormats.dateOnly);
export const formatAolUrlDate = (date: Date) => formatDateTime(date, DateTimeFormat.urlFormats.dateOnly);
export const formatAolFromToTimeUrl = (date: Date) => `${formatDateTime(date, DateTimeFormat.urlFormats.URLDateTime)}`;

export const formatQueryDateOnly = (date: Date) => formatDateTime(date, DateTimeFormat.queryFormats.dateOnly);
